import { NumberChartResponse } from '@app/interfaces/report.type';
import React, { FC } from 'react';
type NumberChartPropsType = {
  data: NumberChartResponse;
};
const NumberChart: FC<NumberChartPropsType> = (props) => {
  const { data } = props;
  const trend = data.comparison?.trend;

  return (
    <div className={` w-full h-full flex items-center justify-center`}>
      <div className="flex items-start gap-[8px]">
        <div
          style={{
            fontSize: data.styles?.text_size + 'px',
            color:
              data.series?.conditional_formatting?.length &&
              data.series?.value &&
              data.series.value >= data.series.conditional_formatting[0].value[0] &&
              data.series.value <= data.series.conditional_formatting[0].value[1]
                ? data.series.conditional_formatting[0].color
                : data.styles?.text_color,
          }}
          className="leading-none"
        >
          {data.series?.value || (
            <span className="text-[#373d3f] text-[14px] flex ">Нет данных.</span>
          )}
        </div>
        {data.comparison?.enabled && (
          <div className="mt-[5%]">
            <span
              style={{ fontSize: data.styles?.comparison_font_size + 'px' }}
              className="text-3color"
            >
              {trend === 'up' ? '↑ ' : trend === 'down' ? '↓ ' : ''}
            </span>
            <span
              style={{
                color:
                  trend === 'up'
                    ? data.styles?.comparison_positive_color
                    : trend === 'down'
                    ? data.styles.comparison_negative_color
                    : '',
                fontSize: data.styles?.comparison_font_size,
              }}
            >
              {data.comparison?.display_value}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NumberChart;
